module.exports = __webpack_public_path__ + "assets/img/102.83854c07.png";